import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
//import Dashboard from "@/pages/Dashboard/Dashboard.vue";

import UserList from "@/views/cadastros/usuarios/List.vue";
import ClienteList from "@/views/cadastros/clientes/List.vue";
import AuditoriaList from "@/views/area/auditoria/List.vue";
import InspecaoList from "@/views/cadastros/inspecao/List.vue";
// Charts
//import Charts from "@/pages/Dashboard/Charts.vue";
//import Widgets from "@/pages/Dashboard/Widgets.vue";

import Auth from './auth';
import AuthPaginaInicial from './auth_pagina_inicial';

import authPages from './auth_pages';
import operacionalRoutes from './operacional';
import cadastrosRoutes from './cadastros';
import adminRoutes from './admin';
import clienteRoutes from './cliente';
import routesPerfilCliente from "./route_perfil_cliente";
import modelosRoutes from "./modelos";

const routes = [
        {
                path: "/",
                redirect: "/dashboard",
                name: "Home"
        },
        /*componentsMenu,
        formsMenu,
        tablesMenu,
        mapsMenu,
        pagesMenu,  */
        authPages,
        routesPerfilCliente,
        operacionalRoutes,
        modelosRoutes,
        adminRoutes,
        clienteRoutes,
        cadastrosRoutes,
        {
                path: "/dashboard",
                component: DashboardLayout,
                beforeEnter: AuthPaginaInicial,
                children: [
                        {
                                path: "dashboard",
                                name: "Dashboard",
                                components: { default: InspecaoList }
                        },
                ]
        }
];



export default routes;
